<template>
<div></div>


</template>

<script>
export default {
  name: "ModalNr1",
}
</script>

<style scoped>

</style>